///<reference path="../require.d.ts"/>

export class CheckedRoomRepository {

    KEY = 'checkedIds';

    observable: Rx.Observable<number[]>;
    _subject: Rx.BehaviorSubject<number[]>;
    canSave: boolean = false;

    constructor() {
        this.canSave = this.canUseLocalStorage();
        this.observable = this._subject = new Rx.BehaviorSubject(this.load());
    }

    canUseLocalStorage(): boolean {
        try {
            if (!localStorage.getItem(this.KEY)) {
                localStorage.setItem(this.KEY, '[]');
            }
            return true;
        } catch (_ignore) {
            try {
                if (!sessionStorage.getItem(this.KEY)) {
                    sessionStorage.setItem(this.KEY, '[]');
                }
                return false;
            } catch (_ignore2) {
                return false;
            }
        }
    }

    getItem(): string {
        try {
            if (this.canSave) {
                return localStorage.getItem(this.KEY);
            } else {
                return sessionStorage.getItem(this.KEY);
            }
        } catch (_ignore) {
            return '[]';
        }
    }

    setItem(value: string): void {
        try {
            if (this.canSave) {
                localStorage.setItem(this.KEY, value);
            } else {
                sessionStorage.setItem(this.KEY, value);
            }
        } catch (_ignore) {}
    }

    load(): number[] {
        return JSON.parse(this.getItem()) as number[];
    }

    save(ids: number[]): void {
        this.setItem(JSON.stringify(ids));
        this._subject.onNext(ids);
    }

    clear(): void {
        this.save([]);
    }

    isChecked(id: number, ids: number[] = this.load()): boolean {
        if (!ids) return false;
        return ids.indexOf(id) >= 0;
    }

    toggle(id: number): void {
        const ids = this.load();
        if (ids.indexOf(id) >= 0) {
            this.save(ids.filter((i) => i !== id));
        } else {
            ids.push(id);
            this.save(ids);
        }
    }


}

angular.module('hp').service('CheckedRoomRepository', CheckedRoomRepository);



// WEBPACK FOOTER //
// ./services/CheckedRoomRepository.ts